module.exports = __webpack_public_path__ + "img/img12.ae74ff1e.svg";